module.exports = __webpack_public_path__ + "media/cyberfox-logo-black.c3687ecf.svg";